export var VisitType;
(function (VisitType) {
    VisitType["INSPECTION_PRIMARY_VISIT"] = "Inspection";
    VisitType["SERVICE_VISIT"] = "Visit";
    // Preemptive new enums for visit refactor:
    VisitType["INSPECTION"] = "inspection";
    VisitType["SERVICE"] = "service";
})(VisitType || (VisitType = {}));
